import { createSelector } from 'reselect';
import { RootState } from 'src/store';

const isPublishing = (state: RootState) => state.pages.editor.scene.publishing;

const isScenePublishing = createSelector([isPublishing], (publishing) => publishing);

export default isScenePublishing;
